module.exports = __webpack_public_path__ + "static/media/cloud.ca6eef80.png";